import { render, staticRenderFns } from "./unbindPage.vue?vue&type=template&id=63b18f81&scoped=true&"
import script from "./unbindPage.vue?vue&type=script&lang=js&"
export * from "./unbindPage.vue?vue&type=script&lang=js&"
import style0 from "./unbindPage.vue?vue&type=style&index=0&id=63b18f81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b18f81",
  null
  
)

export default component.exports